var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"title":_vm.$t('sidebar.title')}},[_c('template',{slot:"links"},[(_vm.sso.attendance)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.peoplemonitoring'),
          img: require('../../assets/img/People.png'),
        }}},[(_vm.sso.attendance.all || _vm.sso.attendance.overview)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Attendance Overview'),
            path: '/Attendance/AttendanceOverview',
          }}}):_vm._e(),(_vm.sso.attendance.all || _vm.sso.attendance.anal)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Attendance Analytic'),
            path: '/Attendance/Analytic',
          }}}):_vm._e(),(_vm.sso.attendance.all || _vm.sso.attendance.overallreport)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.attendreport'),
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Attendance Report'),
              path: '/Attendance/Report/Overall',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Attendance Summary'),
              path: '/Attendance/Report/Summary',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Mobile Report'),
              path: '/Attendance/Report/Mobile',
            }}})],1):_vm._e(),(_vm.sso.attendance.all || _vm.sso.attendance.scheduleedit)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Schedule Edit'),
            path: '/Attendance/ScheduleEdit',
          }}}):_vm._e(),(_vm.sso.attendance.all || _vm.sso.attendance.empmanage)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Employee Management'),
            path: '/Attendance/EmployeeManagement',
          }}}):_vm._e(),(_vm.sso.attendance.all || _vm.sso.attendance.shiftcode)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Shift Code Management'),
            path: '/Attendance/ShiftCodeManagement',
          }}}):_vm._e()],1):_vm._e(),(_vm.sso.asset)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.equipmentmanagementlink'),
          img: require('../../assets/img/Asset.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('Asset Overview'), path: '/Asset/AssetOverview' }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('Asset Analytic'), path: '/Asset/AssetGraph' }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.assetreport'),
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Asset Details Report'),
              path: '/Asset/Report/AssetDetailsReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Asset Location Report'),
              path: '/Asset/Report/AssetLocationReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Asset Repair Report'),
              path: '/Asset/Report/AssetRepairReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Asset Under-repair Report'),
              path: '/Asset/Report/CorrectMaintenance',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('PPM Report'),
              path: '/Asset/Report/PMMMaintenaceReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('PPM Done Report'),
              path: '/Asset/Report/PPMDoneReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('PPM Overdue Report'),
              path: '/Asset/Report/PPMOverdueReport',
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Asset Relocation Request'),
            path: '/Asset/RelocationRequest',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Asset Relocation Approval'),
            path: '/Asset/RelocationApproval',
          }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('Print QR Code'), path: '/Asset/AssetQR' }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.assetmanagement'),
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Asset Registration'),
              path: '/Asset/AssetRegistration',
            }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('Asset Update'), path: '/Asset/AssetUpdate' }}})],1)],1):_vm._e(),(_vm.sso.fleet)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.fleetmonitoring'),
          img: require('../../assets/img/Fleet Management.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehicleoverview'),
            path: '/Fleet/Overview',
          }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.vehiclegraph'), path: '/Fleet/Graph' }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehicleMaintenance'),
            path: '/Fleet/VehicleMaintenance',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehicleRequirement'),
            path: '/Fleet/VehicleRequirement',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehicleSite'),
            path: '/Fleet/VehicleSite',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehicleReplacement'),
            path: '/Fleet/VehicleReplacement',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehicleSearch'),
            path: '/Fleet/VehicleSearch',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehicleRegistration'),
            path: '/Fleet/VehicleRegistration',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.vehiclereport'),
            icon: 'tim-icons icon-chart-pie-36',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.totalVehicleReport'),
              path: '/Fleet/Report/TotalVehicleReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.breakdownReport'),
              path: '/Fleet/Report/BreakdownReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.availabilityReport'),
              path: '/Fleet/Report/AvailabilityReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.replacementReport'),
              path: '/Fleet/Report/ReplacementReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.percentAvailabilityReport'),
              path: '/Fleet/Report/PercentAvailabilityReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.unservicedReport'),
              path: '/Fleet/Report/UnservicedReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.requirementReport'),
              path: '/Fleet/Report/RequirementReport',
            }}})],1)],1):_vm._e(),(_vm.sso.greenCard)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.greenCard'),
          img: require('../../assets/img/Greencard.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.greenOverview'),
            path: '/Greencard/Overview',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.greenAnalytics'),
            path: '/Greencard/Analytics',
          }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.greenReportPage') }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.crossCheck'),
              path: '/Greencard/Report/ScheduleActual',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.offSchedule'),
              path: '/Greencard/Report/ScheduleConsistency',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.missCollection'),
              path: '/Greencard/Report/MissCollection',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.customerRating'),
              path: '/Greencard/Report/CustomerRating',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.customerReview'),
              path: '/Greencard/Report/CustomerReview',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.inspectionReport'),
              path: '/Greencard/Report/InspectionReport',
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.pickupQR'),
            path: '/Greencard/PickupQR',
          }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.customerManagement') }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.customerRegistration'),
              path: '/Greencard/CustomerRegistration',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.customerUpdate'),
              path: '/Greencard/CustomerManagement',
            }}})],1)],1):_vm._e(),(_vm.sso.incident)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.incidentReport'),
          img: require('../../assets/img/Incident.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.incidentOverview'),
            path: '/IncidentReport/IncidentOverview',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.newJKKP'),
            path: '/IncidentReport/NewJKKP',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.updateJKKP'),
            path: '/IncidentReport/UpdateJKKP',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.newInvestigation'),
            path: '/IncidentReport/NewInvestigation',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.updateInvestigation'),
            path: '/IncidentReport/UpdateInvestigation',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.generateReport'),
            path: '/IncidentReport/GenerateReport',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.followUp'),
            path: '/IncidentReport/FollowUp',
          }}})],1):_vm._e(),(_vm.sso.cems)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.CEMS'),
          img: require('../../assets/img/CEMS icon.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.CEMOverview'),
            path: '/CEMS/Overview',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.CEMAnalytic'),
            path: '/CEMS/Analytic',
          }}})],1):_vm._e(),(_vm.sso.cmms)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.CMMS'),
          img: require('../../assets/img/ticket.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.CMMSOverview'),
            path: '/CMMS/Overview',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.CMMSAnalytic'),
            path: '/CMMS/Analytic',
          }}})],1):_vm._e(),(_vm.sso.scada)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.Scada'),
          img: require('../../assets/img/SCADA.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ScadaOverview'),
            path: '/Scada/Overview',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ScadaAnalytic'),
            path: '/Scada/Analytic',
          }}})],1):_vm._e(),(_vm.sso.weigbrige)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.Weighbridge'),
          img: require('../../assets/img/Weightbridge.png'),
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.WeighbridgeOverview'),
            path: '/Weighbridge/Overview',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.WeighbridgeAnalytic'),
            path: '/Weighbridge/Analytic',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.WeighbridgeManagement'),
            path: '/Weighbridge/Management',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Weekly Report'),
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Domestic Waste'),
              path: '/Weighbridge/Report/Weekly/DomesticWaste',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Bulky Waste'),
              path: '/Weighbridge/Report/Weekly/BulkyWaste',
            }}})],1),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Monthly Report'),
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Domestic Waste'),
              path: '/Weighbridge/Report/Monthly/DomesticWaste',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Bulky Waste'),
              path: '/Weighbridge/Report/Monthly/BulkyWaste',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Total Tonnage '),
              path: '/Weighbridge/Report/Monthly/TotalTonnageReport',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('SAS'),
              path: '/Weighbridge/Report/Monthly/SASReport',
            }}})],1)],1):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.userManagement'),
          img: require('../../assets/img/User Management.png'),
          path: '/UserManagement',
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }